import React, { useState } from 'react';
import { UserManagent } from '@/types';
import { Button } from '@/components/ui/button';
import { useUpdateUserStatusMutation } from '@/store/api/userApi';

interface BlockUserButtonProps {
  user: UserManagent;
}

export const BlockUserButton = ({ user }: BlockUserButtonProps) => {
  const [updateStatus, { isLoading }] = useUpdateUserStatusMutation();
  const [isOpen, setIsOpen] = useState(false);
  const isBlocked = user.status === 'Blocked';

  const handleToggle = async () => {
    try {
      const nextStatus = isBlocked ? 'Active' : 'Blocked';
      await updateStatus({ userId: Number(user.id), status: nextStatus }).unwrap();
      setIsOpen(false);
    } catch (err) {
      console.error('Failed to update user status:', err);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        disabled={isLoading}
        onClick={() => setIsOpen(true)}
        className={`h-8 px-3 rounded-lg text-xs font-semibold transition-all border cursor-pointer ${
          isBlocked
            ? 'bg-emerald-200 text-emerald-700 border-emerald-200 hover:bg-emerald-100'
            : 'bg-red-200 text-red-700 border-red-200 hover:bg-red-100'
        }`}
      >
        {isLoading ? 'Updating...' : isBlocked ? 'Unblock' : 'Block'}
      </Button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-xl border border-gray-100 animate-slide-up text-left">
            <h3 className="text-lg font-bold text-gray-900 mb-2">Confirm Action</h3>
            <p className="text-sm text-gray-500 mb-6">
              Are you sure you want to {isBlocked ? 'unblock' : 'block'} user{' '}
              <span className="font-semibold text-gray-700">{user.fullName || user.email}</span>?
            </p>
            <div className="flex justify-end gap-3">
              <Button
                type="button"
                variant="outline"
                onClick={() => setIsOpen(false)}
                className="h-10 px-4 rounded-lg text-sm font-semibold border-gray-200 text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                Cancel
              </Button>
              <Button
                type="button"
                onClick={handleToggle}
                disabled={isLoading}
                className={`h-10 px-4 rounded-lg text-sm font-semibold text-white cursor-pointer ${
                  isBlocked ? 'bg-[#10B981] hover:bg-[#059669]' : 'bg-[#EF4444] hover:bg-[#DC2626]'
                }`}
              >
                {isLoading ? 'Processing...' : isBlocked ? 'Unblock' : 'Block'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
